import { render, staticRenderFns } from "./useDetail.vue?vue&type=template&id=ad3220ec&scoped=true"
import script from "./useDetail.vue?vue&type=script&lang=js"
export * from "./useDetail.vue?vue&type=script&lang=js"
import style0 from "./useDetail.vue?vue&type=style&index=0&id=ad3220ec&lang=scss"
import style1 from "./useDetail.vue?vue&type=style&index=1&id=ad3220ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3220ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad3220ec')) {
      api.createRecord('ad3220ec', component.options)
    } else {
      api.reload('ad3220ec', component.options)
    }
    module.hot.accept("./useDetail.vue?vue&type=template&id=ad3220ec&scoped=true", function () {
      api.rerender('ad3220ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platformCouponManage/useDetail.vue"
export default component.exports